const EventCalendar = () => {
  return <div>EventCalendar</div>
}

export default EventCalendar
